import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Formata data/hora como `DD/MM/YYYY HH:MM` no fuso informado (IANA, ex.
 * "America/Sao_Paulo"), sem segundos e sem prefixo de fuso — para espaços
 * curtos como a barra lateral. ISO sem fuso é tratado como UTC (padrão do
 * backend). Devolve null para valor ausente ou inválido.
 */
export function formatShortDateTime(value, timeZone) {
  if (value == null || value === '') return null;
  let date;
  if (value instanceof Date) {
    date = value;
  } else if (typeof value === 'string') {
    const hasZone = /(?:Z|[+-]\d{2}:?\d{2})$/.test(value);
    date = new Date(hasZone ? value : `${value}Z`);
  } else {
    date = new Date(value);
  }
  if (Number.isNaN(date.getTime())) return null;
  const parts = new Intl.DateTimeFormat('pt-BR', {
    timeZone: timeZone || undefined,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(date);
  const get = (type) => parts.find((p) => p.type === type)?.value ?? '';
  const hour = get('hour') === '24' ? '00' : get('hour');
  return `${get('day')}/${get('month')}/${get('year')} ${hour}:${get('minute')}`;
}
